
import { X } from 'lucide-react';
import { DialogClose } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

/** Botão fechar dos modais do hero (smiley/power descoberto). */
export const discoverDialogCloseClass = cn(
  'absolute z-30 flex h-9 w-9 items-center justify-center rounded-lg',
  'border border-sky-400/25',
  'bg-gradient-to-br from-[#0e1f7a]/95 via-[#0a1450]/95 to-[#060c38]/95',
  'text-sky-200 shadow-[0_2px_10px_rgba(0,0,0,0.35),inset_0_1px_0_rgba(138,171,248,0.12)]',
  'backdrop-blur-sm transition-all duration-200',
  'hover:border-sky-400/40 hover:from-[#112888] hover:via-[#0d1a6e] hover:to-[#0a1450] hover:[&_svg]:text-sky-100',
  'active:scale-95',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/50 focus-visible:ring-offset-2 focus-visible:ring-offset-[#030023]'
);

export function DiscoverDialogClose({
  className,
  onClick,
}: {
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) {
  return (
    <DialogClose
      className={cn(discoverDialogCloseClass, className)}
      onClick={onClick}
    >
      <X className="h-[17px] w-[17px] text-sky-200" strokeWidth={2.5} aria-hidden />
      <span className="sr-only">Fechar</span>
    </DialogClose>
  );
}
